module.exports = __webpack_public_path__ + "img/Rectangle Copy 17@2x.bf22bc22.png";